import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import io.jsonize.web.App
import io.jsonize.web.navigation.NavController
import io.jsonize.web.services.FileExport
import io.jsonize.web.services.FileExportImpl
import io.jsonize.web.services.PlatformStorage
import io.jsonize.web.services.PlatformStorageImpl
import io.jsonize.web.viewmodel.AppViewModel

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    PlatformStorage.default = PlatformStorageImpl()
    FileExport.default = FileExportImpl()
    val viewModel = AppViewModel()
    val nav = NavController()

    ComposeViewport(viewportContainerId = "app-root") {
        App(nav = nav, vm = viewModel)
    }
}
